import { AuditLogTable } from 'src/components/molecules';
import { AuditEntryType, useGetCategoriesAuditEntriesQuery } from 'src/graphql';
import { formatDateTime } from 'src/utils/commonFunctions';

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isCOI?: boolean;
}

export const CategoriesAuditLogTable = ({
  isOpen,
  setIsOpen,
  isCOI = false,
}: Props) => {
  const { data: categoriesAuditEntries } = useGetCategoriesAuditEntriesQuery({
    isCOI,
  });

  const columns = [
    { label: 'User' },
    { label: 'Category name' },
    { label: 'Event' },
    { label: 'Timestamp' },
  ];

  const tableDataCallback = (entry: AuditEntryType) => {
    const localeUpdated = entry?.action?.includes('LOCALE');
    const orderUpdated = entry?.action?.includes('REORDERED');
    const lowerEvent =
      entry?.action
        ?.replace('_CATEGORY', '')
        .replace('_LOCALE', '')
        .replace('_REORDERED', '')
        .toLowerCase() ?? '';
    const event = `Category${localeUpdated ? ' locale' : ''} ${
      orderUpdated ? 'order update' : lowerEvent
    }d`;

    const localeNewName = entry?.data?.newName || entry?.data?.oldName;
    const categoryName = localeUpdated ? localeNewName : entry?.data?.name;

    return {
      cellData: [
        entry.User?.name || entry.User?.displayName || 'System',
        categoryName || 'Untitled',
        event,
        formatDateTime(new Date(entry.createdAt)),
      ],
      row: `${entry.id}`,
    };
  };

  return (
    <AuditLogTable
      auditLogEntries={
        (categoriesAuditEntries?.categoriesAuditEntries as AuditEntryType[]) ??
        []
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      columns={columns}
      tableDataCallback={tableDataCallback}
      emptyText="No category audit log entries."
    />
  );
};
